import type { Image } from '@/features/photoset/types'
import { formatMetadataValue } from '@/features/photoset/utils'
import { useTranslation } from '@/translations/i18n'

export const GalleryMetadata = ({
	imageMetadata
}: {
	imageMetadata: Image['metadata']
}) => {
	const { t } = useTranslation()

	if (!imageMetadata) {
		return <p className='p-6'>{t('errors:metadata_unavailable')}</p>
	}

	return imageMetadata.map((metaElement) => (
		<div
			className='mx-3 flex gap-4 border-neutral-200 border-b px-3 py-1.5 text-xs'
			key={metaElement.type}
		>
			<div className='min-w-[110px]'>
				{t(`photoset:metadata.${metaElement.type}`)}
			</div>

			<div className='font-medium text-neutral-700 text-xs'>
				{formatMetadataValue(metaElement.type, metaElement.value)}
			</div>
		</div>
	))
}
